export default "__VITE_ASSET__28c7d1cc__"